<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_ORDER_EXPORT_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết phiếu xuất kho</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
        <button class="btn font-medium btn-outline-secondary" @click="inTicket(detail.id)">
          <i class="bx bx-copy"></i><span>&nbsp;</span>In phiếu
        </button>
        <button
          v-if="
            detail.status === 'SUCCESS' &&
            this.dataPermission.includes('CNPS_DEVICE_ORDER_CHANGE_DATE_COMPLETE')
          "
          class="btn font-medium btn-outline-secondary"
          @click="editDate()"
        >
          <i class="bx bx-edit"></i><span>&nbsp;</span>Sửa ngày hoàn thành phiếu
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-detail">
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số phiếu xuất<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ detail.billNumber }}</p>
                  </div>
                </div>

                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Trạng thái<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      <span class="badge" :class="[detail.status ? detail.status : '']">{{
                        detail.status | mapTextStatus(statusExportWarehouse)
                      }}</span>
                    </p>
                  </div>
                </div>

                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do xuất<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.reasonExport | transformData(optionReason) }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Kho xuất<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p
                      type="button"
                      class="form-control-plaintext f12 text-primary"
                      @click="$router.push(`/cat-warehouse/${detail.inventoryIdExport}`)"
                    >
                      {{ detail.inventoryNameExport }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.reasonExport === 'EXPORT_TRANSFER'">
                  <label for="" class="col-sm-4 col-form-label"
                    >Kho nhập<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p
                      type="button"
                      class="form-control-plaintext f12 text-primary"
                      @click="$router.push(`/cat-warehouse/${detail.inventoryIdImport}`)"
                    >
                      {{ detail.inventoryNameImport }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.reasonExport === 'EXPORT_SELL'">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên MC<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ detail.merchantName }}</p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.reasonExport === 'EXPORT_SELL'">
                  <label for="" class="col-sm-4 col-form-label"
                    >Địa chỉ MC<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail?.addressPayments?.join(', ') }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.reasonExport === 'EXPORT_SELL'">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã HĐ/PL<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ detail.contractCode }}</p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.reasonExport === 'EXPORT_SELL'">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã phiếu thu<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ detail.receiptCode }}</p>
                  </div>
                </div>

                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày xuất<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ detail.timeExport | formatDate }}</p>
                  </div>
                </div>

                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian tạo<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Người tạo<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.userCreator && detail.userCreator.name }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.timeApprove !== 0">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian duyệt<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.timeApprove !== 0">
                  <label for="" class="col-sm-4 col-form-label"
                    >Người duyệt<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.personApprove && detail.personApprove.name }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.timeReject !== 0">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian từ chối<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.timeReject | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.timeReject !== 0">
                  <label for="" class="col-sm-4 col-form-label"
                    >Người từ chối<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ detail.personReject && detail.personReject.name }}
                    </p>
                  </div>
                </div>

                <div class="form-group form-row" v-if="detail.timeReject !== 0">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do từ chối<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ detail.reasonReject }}</p>
                  </div>
                </div>
              </div>
              <div class="form-detail" v-if="detail.devices && detail.devices.length > 0">
                <h1>Thông tin thiết bị</h1>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col" class="text-left">Tên thiết bị</th>
                        <th scope="col" class="text-left">Dịch vụ</th>
                        <th scope="col" class="text-left">Serial</th>
                        <th scope="col" class="text-left">Số lượng</th>
                        <th scope="col" class="text-left">Tình trạng</th>
                      </tr>
                    </thead>
                    <tbody v-for="(item, index) in detail.devices" :key="index">
                      <tr class="table-row">
                        <td align="left">{{ item.categoryName }}</td>
                        <td align="left">{{ item.services ? item?.services?.join(',') : '' }}</td>
                        <td align="left">{{ item.serial }}</td>
                        <td align="left">{{ item.quantity }}</td>
                        <td align="left">
                          <span
                            v-if="item.kind === 'SERIAL'"
                            class="badge"
                            :class="[item.status ? item.status : '']"
                          >
                            {{ item.status | transformData(optionStatus) }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ChangeDate :id="id" @updateDateComplete="updateDateComplete" />
  </div>
</template>
<script>
  import Config from '../../../thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import ChangeDate from '@/components/ChangeDate.vue'
  export default {
    data() {
      return {
        loading: false,
        id: this.$route.params.id,
        detail: {},
        optionReason: Config.reasonExport,
        optionStatus: Config.statusDevices,
        statusExportWarehouse: Config.statusExportWarehouse,
      }
    },
    components: { ChangeDate },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    created() {
      this.fetchData()
    },

    methods: {
      async inTicket(id) {
        this.loading = true
        try {
          const res = await DeviceService.detailExportWarehouse({ id })
          const data = res.data
          data.devicesTotalAmount = data.devices.reduce((t, i) => t + i.price, 0)
          await DeviceService.inExportTicket({ data })
        } catch (error) {
        } finally {
          this.loading = false
        }
      },
      backToList() {
        this.$router.push('/export-warehouse')
      },

      async fetchData() {
        try {
          this.loading = true
          const data = await DeviceService.detailExportWarehouse({
            id: this.id,
          })
          if (data.success) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      editDate() {
        this.isShowChangeDate = true
        this.$bvModal.show('change-date')
      },
      async updateDateComplete(data) {
        try {
          this.loading = true
          const response = await DeviceService.editDateComplete({
            id: this.id,
            date: data,
          })
          if (response.code === 1000 || response.success) {
            this.showSuccessMx('Cập nhật thành công!')
            this.$bvModal.hide('change-date')
            this.isShowChangeDate = false
            this.fetchData()
          } else this.showFailMx(response.message)
        } catch (error) {
          this.showFailMx(error.message)
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
